import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  padding: ${({ theme }) => `0 ${theme.x2spacePx}px`};
  padding-bottom: ${({ theme }) => theme.x5spacePx}px;
`;

export const Content = styled(Grid)`
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  background: ${({ theme }) => theme.color.noir};
`;
